import './app.css';

import WebFont from 'webfontloader';
import lazySizes from 'lazysizes';
import {analyticsEvent, attrEvents} from './js/analytics';

/* is production */
const isProd = process.env.NODE_ENV === 'production';

/* service worker */
if ('serviceWorker' in navigator && isProd) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('./sw.js');
    });
}

/* fonts */
WebFont.load({
    custom: {
        families: ['Circe:n3,n4'],
        urls: ['./css/fonts.css']
    }
    /*
    google: {
        families: ['Roboto:400,700:cyrillic']
    },
    typekit: {
        id: 'fkm4zbt'
    }*/
});

/* analytics (EXAMPLE: analyticsEvent('Button', 'click', 'Play');) */
analyticsEvent();
attrEvents();
// analyticsEvent('Page', 'load', 'Start');

/* lazy loading (https://github.com/aFarkas/lazysizes) */
lazySizes.init();

/* share buttons with lazyloading */
const shareButtonsContainer = document.querySelector('.share');
if (shareButtonsContainer !== null) {
    shareButtonsContainer.addEventListener('lazyloaded', () => {
        import(/* webpackPrefetch: true */ './js/share').then(func => {
            func.default();
        });
    });
}

/* webp pictures */
const webpElements = [...document.querySelectorAll('[data-webp][data-webp-fallback]')];
if (webpElements.length > 0) {
    import(/* webpackPrefetch: true */ './js/webp').then(func => {
        func.default(webpElements);
    });
}

// import '@babel/polyfill';
require('./js/viscom/mastercard/businesscards/ProjectApp');
